import React from 'react';
import ReactSelectAsync from '../../selects/react-select-async';
import '../fieldstyle.css'

const FieldSelectAsync = ({ input, label ,disabled, loadOptions, meta: { touched, error, invalid, warning } }) => (
    <div className={`grupo-form ${touched && invalid ? 'tiene-error' : ''}`}>
    <label className='label-control'>{label}</label>
    <div>
      < ReactSelectAsync {...input} value={input.value} func_onChange={(value) => {if(Array.isArray(value)){value=null}; input.onChange(value);}} func_onBlur={() => input.onBlur(input.value)} func_loadOptions={loadOptions}
      disabled={disabled}/>
      <div className='descrip-error'>
      {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
      </div>
    </div>
  </div>
)
export default FieldSelectAsync